import {
    createContext,
    useContext,
    useEffect,
    useState,
    type ReactNode,
} from 'react';
import {
    clearRegistrationState,
    getAccount,
    getAccountId,
    getPartner,
    setAccount,
    setAccountId,
    setError,
    setPartnerInfo,
    subscribeRegistrationState,
} from '../utils/storage';

type RegistrationContextValue = ReturnType<typeof readRegistrationState>;

const RegistrationContext = createContext<RegistrationContextValue | null>(null);

function readRegistrationState() {
    return {
        accountId: getAccountId(),
        partner: getPartner(),
        account: getAccount(),
        setAccountId,
        setPartnerInfo,
        setAccount,
        setError,
        clearRegistrationState,
    };
}

export function RegistrationProvider({ children }: { children: ReactNode }) {
    const [state, setState] = useState(readRegistrationState);

    useEffect(
        () => subscribeRegistrationState(() => setState(readRegistrationState())),
        []
    );

    return (
        <RegistrationContext.Provider value={state}>{children}</RegistrationContext.Provider>
    );
}

export function useRegistration() {
    const ctx = useContext(RegistrationContext);
    if (!ctx) {
        throw new Error('useRegistration must be used within RegistrationProvider');
    }
    return ctx;
}
